import { render, staticRenderFns } from "./wellBeingIcon.vue?vue&type=template&id=687c2796"
import script from "./wellBeingIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./wellBeingIcon.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports